module.exports = __webpack_public_path__ + "img/box.11ce44c4.png";